import PayPage from './PayPage';

export default PayPage;
